module.exports = __webpack_public_path__ + "static/gqueues-561d621c9eec2afb0e3571828ce30c90.png";